module.exports = __webpack_public_path__ + "static/media/png.a9f3ad01.svg";